/**
 * 문서서비스 연락처의 길이가 50자로 제한되어 있습니다.
 * 이메일 입력에 대한 최대 길이 제한이 느슨하게 되어 있어서 서버 유효성과 맞지 않습니다.
 * 자세한 내용 및 맥락 이해는 슬랙 스레드 참고 부탁드립니다.
 * https://modusign.slack.com/archives/CKFPEGU23/p1654223827725929
 */
// eslint-disable-next-line import/prefer-default-export
export const CONTACT_INFO_MAX_LENGTH = 50;
